import { render, staticRenderFns } from "./TopicMove.vue?vue&type=template&id=6f0a4488&scoped=true"
import script from "./TopicMove.vue?vue&type=script&lang=js"
export * from "./TopicMove.vue?vue&type=script&lang=js"
import style0 from "./TopicMove.vue?vue&type=style&index=0&id=6f0a4488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a4488",
  null
  
)

export default component.exports